import { memo } from 'react';
import { OrderbookLiquidityLegend } from 'src/components/Orderbook/OrderbookLiquidityLegend';
import { BigNum } from '@drift-labs/sdk';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { getFormattedSpreadQuote } from 'src/components/Orderbook/OrderbookUtils';

interface Props {
	isLoading: boolean;
	spreadQuote: BigNum | undefined;
	spreadPct: BigNum | undefined;
	isMini?: boolean;
	baseAssetSymbol?: string;
	tickSizeDecimalPlaces: number;
}

function OrderbookFooter({
	isMini,
	isLoading,
	spreadQuote,
	spreadPct,
	baseAssetSymbol,
	tickSizeDecimalPlaces,
}: Props) {
	const isMobileScreenSize = useIsMobileScreenSize();

	// On mobile, we only show it on the mini OB.
	if (isMobileScreenSize && !isMini) {
		return null;
	}

	const showFallback =
		isLoading || spreadQuote === undefined || spreadPct === undefined;

	const spreadValue = (() => {
		if (showFallback) {
			return '-';
		}

		if (isMini) {
			return `${spreadPct.toFixed(3)}%`;
		}

		const formattedSpreadQuote = getFormattedSpreadQuote({
			baseAssetSymbol,
			tickSizeDecimalPlaces,
			spreadQuote,
		});

		return `$${formattedSpreadQuote} (${spreadPct.toFixed(3)}%)`;
	})();

	return (
		<div className="flex items-center justify-between p-sm typo-b4 text-text-secondary">
			<span>Spread: {spreadValue}</span>
			{!isMini && <OrderbookLiquidityLegend />}
		</div>
	);
}

export default memo(OrderbookFooter);
